/* ITRANAH product page: "Customers also add" upsell + "Build your trio" bundle builder. */
(function () {
  'use strict';

  var settings = function () { return window.MinimogSettings || {}; };

  function money(cents) {
    var s = settings();
    try {
      if (typeof window.formatMoney === 'function' && s.money_format) {
        return window.formatMoney(cents, s.money_format).replace(/\.00(?!\d)/, '');
      }
    } catch (e) { /* fall through */ }
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  // Add several variants in one request, then refresh/open the theme's cart drawer.
  function addItems(items) {
    var s = settings();
    var url = (s.routes && s.routes.cart_add_url ? s.routes.cart_add_url : '/cart/add') + '.js';
    url = url.replace(/\.js\.js$/, '.js');
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'Could not add to cart');
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && s.enable_cart_drawer !== false && s.use_ajax_atc !== false) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        } else if (s.routes && s.routes.cart) {
          window.location = s.routes.cart;
        } else {
          window.location = '/cart';
        }
        return res;
      });
  }

  /* ---------- Upsell: add every ticked add-on right after the main product is added ---------- */
  if (!customElements.get('itr-upsell')) {
    customElements.define('itr-upsell', class extends HTMLElement {
      connectedCallback() {
        this.checks = Array.prototype.slice.call(this.querySelectorAll('.itr-upsell__check'));
        this.totalEl = this.querySelector('[data-total]');
        this.productId = String(document.body.dataset.productId || '');
        this.onAdded = this.onAdded.bind(this);
        this.update = this.update.bind(this);
        document.addEventListener('product-ajax:added', this.onAdded);
        var self = this;
        this.checks.forEach(function (c) { c.addEventListener('change', self.update); });
        this.querySelectorAll('[data-variant-select]').forEach(function (sel) {
          sel.addEventListener('change', function () { self.onVariant(sel); });
        });
        this.querySelectorAll('[data-size]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.onSize(btn); });
        });
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('product-ajax:added', this.onAdded);
      }
      onVariant(sel) {
        var item = sel.closest('.itr-upsell__item');
        var check = item && item.querySelector('.itr-upsell__check');
        var opt = sel.options[sel.selectedIndex];
        if (!check || !opt) return;
        check.dataset.variantId = opt.value;
        check.dataset.price = opt.dataset.price || '0';
        var now = item.querySelector('[data-price-now]');
        var was = item.querySelector('[data-price-was]');
        if (now) now.textContent = opt.dataset.priceLabel || now.textContent;
        if (was) { was.textContent = opt.dataset.wasLabel || ''; was.hidden = !opt.dataset.wasLabel; }
        this.update();
      }
      onSize(btn) {
        var item = btn.closest('.itr-upsell__item');
        var check = item && item.querySelector('.itr-upsell__check');
        if (!check) return;
        item.querySelectorAll('[data-size]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        check.dataset.variantId = btn.dataset.id;
        check.dataset.price = btn.dataset.price || '0';
        var now = item.querySelector('[data-price-now]');
        var was = item.querySelector('[data-price-was]');
        if (now) now.textContent = btn.dataset.priceLabel || now.textContent;
        if (was) { was.textContent = btn.dataset.wasLabel || ''; was.hidden = !btn.dataset.wasLabel; }
        check.checked = true; // picking a size means "I want this one"
        this.update();
      }
      picked() {
        return this.checks.filter(function (c) { return c.checked; });
      }
      update() {
        if (!this.totalEl) return;
        var p = this.picked();
        if (!p.length) { this.totalEl.hidden = true; return; }
        var sum = p.reduce(function (t, c) { return t + Number(c.dataset.price || 0); }, 0);
        var label = p.length === 1 ? this.dataset.labelOne : this.dataset.labelMany;
        this.totalEl.innerHTML = '<span>' + p.length + ' ' + (label || 'add-ons') + '</span><strong>+ ' + money(sum) + '</strong>';
        this.totalEl.hidden = false;
      }
      onAdded(e) {
        var p = this.picked();
        if (!p.length || window.__itrAdding) return;
        var added = e.detail && e.detail.product;
        // Only react to this page's main product form, not to other quick-adds.
        if (!added || String(added.product_id) !== this.productId) return;
        var self = this;
        var items = p.map(function (c) { return { id: Number(c.dataset.variantId), quantity: 1 }; });
        window.__itrAdding = true;
        addItems(items)
          .then(function () {
            p.forEach(function (c) { c.checked = false; });
            self.update();
          })
          .catch(function (err) { console.warn('[itr-upsell]', err); })
          .finally(function () { window.__itrAdding = false; });
      }
    });
  }

  /* ---------- Build your trio ---------- */
  if (!customElements.get('itr-bundle')) {
    customElements.define('itr-bundle', class extends HTMLElement {
      connectedCallback() {
        this.max = Number(this.dataset.max || 2);
        this.t2 = Number(this.dataset.tier2 || 0);
        this.t3 = Number(this.dataset.tier3 || 0);
        this.base = this.querySelector('.itr-tile.is-locked');
        this.tiles = Array.prototype.slice.call(this.querySelectorAll('button.itr-tile'));
        this.picked = [];
        var self = this;
        this.tiles.forEach(function (t) {
          t.addEventListener('click', function () { self.toggle(t); });
        });
        // Pre-select the first option so the offer is visible straight away.
        if (this.tiles[0]) this.toggle(this.tiles[0]);
        this.addBtn = this.querySelector('[data-add]');
        if (this.addBtn) this.addBtn.addEventListener('click', this.add.bind(this));
        this.render();
      }
      toggle(tile) {
        var i = this.picked.indexOf(tile);
        if (i > -1) {
          this.picked.splice(i, 1);
        } else {
          this.picked.push(tile);
          if (this.picked.length > this.max) this.picked.shift();
        }
        this.render();
      }
      render() {
        var self = this;
        this.tiles.forEach(function (t) {
          var on = self.picked.indexOf(t) > -1;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
          var pill = t.querySelector('[data-pill]');
          if (pill) { pill.textContent = on ? 'Added' : '+ Add'; pill.classList.toggle('is-on', on); }
        });
        var count = 1 + this.picked.length;
        var sub = Number(this.base.dataset.price || 0);
        this.picked.forEach(function (t) { sub += Number(t.dataset.price || 0); });
        var pct = count >= 3 ? this.t3 : count === 2 ? this.t2 : 0;
        var disc = Math.round(sub * pct / 100);
        var q = function (sel) { return self.querySelector(sel); };
        q('[data-count-label]').textContent = count + (count === 1 ? ' attar' : ' attars');
        q('[data-subtotal]').textContent = money(sub);
        q('[data-pct]').textContent = pct;
        q('[data-discount]').textContent = money(disc);
        q('[data-total]').textContent = money(sub - disc);
        var hint = q('[data-hint]');
        if (hint) {
          if (count === 1) hint.textContent = 'Add one more to get ' + this.t2 + '% off.';
          else if (count === 2 && this.max >= 2) hint.textContent = 'Add one more to get ' + this.t3 + '% off.';
          else hint.textContent = 'Best value unlocked.';
        }
        var lbl = q('[data-add-label]');
        if (lbl) lbl.textContent = count === 1 ? 'Add to cart' : 'Add ' + count + ' to cart';
        this.querySelectorAll('.itr-step').forEach(function (st) {
          st.classList.toggle('is-on', Number(st.dataset.step) <= count);
        });
      }
      add() {
        var self = this;
        var err = this.querySelector('[data-error]');
        var items = [{ id: Number(this.base.dataset.variantId), quantity: 1 }];
        this.picked.forEach(function (t) { items.push({ id: Number(t.dataset.variantId), quantity: 1 }); });
        this.addBtn.disabled = true;
        this.addBtn.classList.add('is-loading');
        if (err) err.hidden = true;
        window.__itrAdding = true;
        addItems(items)
          .catch(function (e) {
            if (err) { err.textContent = e.message; err.hidden = false; }
          })
          .finally(function () {
            window.__itrAdding = false;
            self.addBtn.disabled = false;
            self.addBtn.classList.remove('is-loading');
          });
      }
    });
  }
})();
